// Centralized z-index configuration for layered UI elements
// Keep in sync with any CSS utilities (e.g., .z-toast) and docs/ui/z_index_hierarchy.md

export const Z_INDEX_LAYERS = {
  DROPDOWN_BASE: 20,
  DIALOG_BASE: 60,
  DROPDOWN_IN_DIALOG: 1000,
}

// Small offset to ensure panels sit above their backdrops at the same layer
export const Z_INDEX_STEP = 1

